<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="$t('设备信息设置')"
    width="800px"
    class="mn606-alarm-threshold-settings"
    top="10vh"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    element-loading-text="Loading"
  >
    <div class="alarm-threshold-settings-611_content scrollbar-thin">
      <MForm ref="form" v-bind="form">
        <template #params="{ model, config }">
          <MForm :config="config.cfg" :model="model" />
        </template>
      </MForm>
    </div>
    <div class="action-wrap">
      <el-button @click="handleClose(null)" :loading="loading">{{ $t('关闭') }}</el-button>
      <el-button type="primary" @click="saveHandle" :loading="saveLoading">
        {{ $t('保存') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { awaitTo } from '@/utils/utils';
import { updateDeviceInfo } from '@/api/devices';

import MForm from '@/components/form/index.vue';

export default {
  components: {
    MForm
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  computed: {
    ...mapState('socket', ['devicesSourseMap', 'deviceSNMap']),

    currentChooseDevice() {
      return this.deviceSNMap[this.sn || this.$route.params.sn];
    }
  },
  data() {
    return {
      i18nPath: 'component.bmap',
      loading: false,
      saveLoading: false,
      form: {
        i18nPath: 'threshold',
        config: {
          labelWidth: 'auto',
          span: 24,
          options: [
            {
              span: 14,
              type: 'input',
              prop: 'name',
              dataKey: 'name',
              label: this.$t('名称')
            },
            {
              span: 14,
              type: 'input',
              prop: 'locationDesc',
              dataKey: 'locationDesc',
              label: this.$t('设备位置')
            },
            {
              span: 14,
              type: 'input',
              prop: 'longitude',
              dataKey: 'longitude',
              label: this.$t('经度')
            },
            {
              span: 14,
              type: 'input',
              prop: 'latitude',
              dataKey: 'latitude',
              label: this.$t('纬度')
            }
          ]
        },
        model: {
          name: '',
          locationDesc: '',
          longitude: '',
          latitude: ''
        },
        rules: {
          name: [{ required: true, message: '请填写设备名称', trigger: 'blur' }]
        }
      }
    };
  },
  methods: {
    initBasicData() {
      let { name, longitude, latitude } = this.currentChooseDevice;
      this.form.model = {
        sn: this.sn,
        name,
        longitude,
        latitude,
        locationDesc: this.currentChooseDevice?.dynamicInfoMap?.location_desc
      };
    },
    reset(index) {
      Object.assign(this.tableConfig.data[index], this.rawData[index]);
    },
    async saveHandle() {
      if (this.saveLoading) return;
      this.saveLoading = true;
      const [, res] = await awaitTo(this.$refs.form.validate());

      if (!res) return (this.saveLoading = false);

      const [err, _res] = await awaitTo(updateDeviceInfo(this.form.model));

      this.saveLoading = false;

      if (err) {
        this.$message({
          type: 'error',
          message: this.$t('保存失败')
        });
        return;
      }

      this.$message({
        type: 'success',
        message: '设备名称修改成功,2分钟后生效'
      });
      this.handleClose();
    },
    handleClose(done) {
      this.$destroy();
      if (done) done?.();
    }
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.initBasicData();
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.mn606-alarm-threshold-settings {
  box-sizing: border-box;

  &_content {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-dialog {
    height: calc(100vh - 20vh);

    max-width: 65vw;

    &__body {
      height: calc(100% - 55px);
      box-sizing: border-box;
    }

    .action-wrap {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
